export default new class throughPopup {
  constructor() {
    this.popupSelector = 'through-popup';
    this.popupHiddenSelector = 'through-popup__hidden';
    this.popupCloseSelector = 'through-popup__close';
    this.popupCodeAttribute = 'data-popup-id';

    this.popupContainerSelector = 'through-popup__wrapper';

    this.cookieThroughPopup = 'through-popup';
    this.removeDelay = 500;
    this.delay = 3500;

    this.isShow = false;

    this.init();
    this.close();
  }

  init() {
    $.request('AlertList::onGetAlert', {
      data: {
        type: 'popup',
      },
      complete: (res) => {
        if (res.responseJSON.status) {
          this.createPopup(res.responseJSON);
        }
      },
    });
  }

  createPopup(res) {
    const arAlertList = res.data;
    $.request('onAjax', {
      data: {
        arAlertList,
      },
      update: {
        'content/through-popup/through-popup-ajax': `.${this.popupContainerSelector}`,
      },
      complete: () => {
        this.openPopup();
        this.close();
      },
    });
  }

  openPopup() {
    setTimeout(() => {
      const popupPanel = document.querySelector(`.${this.popupSelector}`);
      popupPanel.classList.remove(this.popupHiddenSelector);
    }, this.delay);
  }

  close() {
    $(document).on('click', `.${this.popupCloseSelector}`, (e) => {
      const sliderCode = e.currentTarget.getAttribute(this.popupCodeAttribute);
      if (sliderCode) {
        $.request('AlertList::onCloseAlert', {
          data: {
            code: sliderCode,
          },
          complete: () => {
            const popupPanel = document.querySelector(`.${this.popupSelector}`);
            popupPanel.classList.add(this.popupHiddenSelector);
          },
        });
      }
    });
  }
}();
